/**
 * @mixin
 * Sharable mixin for notification use
 * Shares global methods
 */
export default {
    methods: {
		/**
        * @public
        * @description
        * Receives and passes on a notification event from a child component. 
        * USed to surface system messages from any screen / component
        *
        * @param {String} type The notification type to display
        * @param {String} text The notification text to display
        * @param {Boolean} dismissible Whether the notification can be dismissed 
        * @param {String|Integer} duration A string specifying the duration or an integer in milliseconds. 0 plus dismissible means it must be dismissed
        * @returns void
        */
       showNotification(type, text, dismissible, duration, colour) {
			// TODO: Refactor notification service to use event bus to make it globally available for each level component
            /**
            * @event componentLoadInfo
            * @type {object}
            * @description
            * Passes the data on to the next level
            * 
            * @property {String} type The notification type to display
            * @property {String} text The notification text to display
            * @property {Boolean} dismissible Whether the notification can be dismissed 
            * @property {String|Integer} duration A string specifying the duration or an integer in milliseconds. 0 plus dismissible means it must be dismissed
            * @property { String } colour A HEX value of the colour for the notification
            */
            this.$emit('showNotification', type, text, dismissible, duration, colour);
		},

		/**
        * @public
        * @description
        * Receives and passes on a notification event from a child component. 
        * USed to surface system messages from any screen / component
        *
        * @param {String} type The notification type to display
        * @param {String} text The notification text to display
        * @param {Boolean} dismissible Whether the notification can be dismissed 
        * @param {String|Integer} duration A string specifying the duration or an integer in milliseconds. 0 plus dismissible means it must be dismissed
        * @returns void
        */
		showNotificationQuery(type, text, dismissible, duration, colour) {
		   let appNode = this.$cs_.querySelectorVue(this.$root, {name: 'cs-app'});
		   
			if (appNode != undefined) {
			   appNode.showNotification(type, text, dismissible, duration, colour);
		   }
		},
		

	}
}
